import { render, staticRenderFns } from "./SelectionBlackbookModal.vue?vue&type=template&id=85f1138a"
import script from "./SelectionBlackbookModal.vue?vue&type=script&lang=js"
export * from "./SelectionBlackbookModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports